<script setup lang="ts">
import type { Conversation } from "@/conversations/types";
import { formatDatetime } from "@/utils/toFormattedDatetime";
import { Heart } from "@iconoir/vue";
import { RouterLink } from "vue-router";
const { conversation } = defineProps<{
  conversation: Conversation;
}>();
</script>

<template>
  <dl>
    <div>
      <dt>
        <Heart /><span class="visually-hidden">Haustürgesprächsaktion</span>
      </dt>
      <dd>{{ conversation.canvassName }}</dd>
    </div>
    <div v-if="conversation.contactId">
      <dt>Kontakt:</dt>
      <dd>
        <RouterLink
          :to="{
            name: 'canvassFlowEditContact',
            params: { contactId: conversation.contactId },
          }"
          >{{ conversation.contactName }}</RouterLink
        >
      </dd>
    </div>
    <div>
      <dt>angelegt am:</dt>
      <dd>{{ formatDatetime(conversation.createdAt) }}</dd>
    </div>
    <div>
      <dt>angelegt von:</dt>
      <dd>{{ conversation.createdByUserName ?? "n/a" }}</dd>
    </div>
  </dl>
</template>

<style scoped>
dd > svg {
  margin-inline-end: var(--spacing-sm);
}
</style>
